/* eslint-disable react/jsx-one-expression-per-line */
import React, { PureComponent } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import getLink from '../config/urls'
import MobileMenuItem from './constructs/mobile-menu-item'
import LanguageMenu from './constructs/languageMenu'
import HoverMenu from './constructs/hoverMenu'
import LogoSvg from './primitives/logo-svg'
import { media } from './utilities/styled'
import ChatScript from './head/chat-script'


const StyledHeader = styled.header`
  position: relative;
  width:100%;
  &.open {
    z-index: 1;
  }
`
const StyledMenuItem = styled.div`
`

const StyleMenuItemSpan = styled.span`
font-size: 20px;
line-height: 28px;
font-family: elsevier-sans;
`

const StyledSelectCurrency = styled.select`
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("/images/downarrow.svg");
    background-repeat: no-repeat;
    background-position: right center;
    padding-right: 30px; 
    padding-left:10px;
    font-size: 20px;
    line-height: 28px;
    font-family: elsevier-sans;
    font-feature-settings: 'pnum' on,'lnum' on;
    color: #333;
    border:none;
    background-color: transparent;
    height: 50px;

    select option {
      height: 50px;
      font-family: elsevier-sans;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #2E2E2E;
      padding: 30px;      
    }

    select option:hover {
      background-color: #000;
    }
    select option div {
      font-size: 20px;
    line-height: 28px;
    font-family: elsevier-sans;
      display: block; 
      padding: 10px;
    }
  
`
const StyledCurrencyTitle = styled.span`    
font-family: elsevier-sans;
font-size:20px;  
visibility: visible;
@media (max-width: 1400px) {
  visibility: hidden; 
  display:none; 
}  
`

const StyledTitle = styled.div`
  display: block;
  margin-block-start: 0.67em;
  margin-block-end: 0.67em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  color: #f36d21;
  font-size: 24px;
  line-height: 1.16667;
  font-weight: 500;
  margin-left: 16px !important;
  transition: font-size 0.3s, margin-left 0.3s;
  margin: 0;
  padding: 0;
`

const StyledButtons = styled.div`
  a {
    margin-left: 20px;
    line-height: 2rem;

    &:first-child {
      margin-left: 0;
    }
  }
`

const MobileMenuTitle = styled.p`
  color: ${props => props.theme.colors.grey3}!important;
  width: fit-content;
  margin-bottom: 16px !important;
  margin-top: ${props => !props.noMargin && '32px'} !important;
`
const IconSVG = styled.div`
  margin-top:3px;
  float:left
`
const StyledHeaderNav = styled.div`
z-index: 8;
position: relative;
`


let initials = ''

// const API_URL = getLink('apiUrl')

class Header extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      user: '',
    }
  }

  componentDidMount() {  
    // $.ajax({
    //   url: API_URL,
    //   dataType: 'jsonp',
    //   cache: false,
    //   error: function error(xhr, textStatus) {
    //     // eslint-disable-next-line no-console
    //     console.log('error when querying api, reason:', textStatus)
    //   },
    //   success: function success(data) {
    //     // Check if user have an ID+ cookie (isIdPlusAuthorizedUser)
    //     // If not redirect to the Elsevier ID+ login page + URL redirect
    //     if (navigator.cookieEnabled === true && data.isIdPlusAuthorizedUser === false) {
    //       window.location.replace(
    //         getLink('loginUrl').replace('{returnUri}', encodeURIComponent(window.location.href)),
    //       )
    //     }
    //     // When user is logged parse customerFullname and create initials
    //     this.setState({ user: data })
    //   }.bind(this),
    // })
  }


  render() {
    const { menuOpen, setMenuOpen, popupOpen, setPopup, t, i18n } = this.props
    const { user } = this.state

    const menuLinks = {      
      languageEditing: [
        { title: t('standard'), link: '/language-editing/' },
        { title: t('plus'), link: '/language-editing/' },
        { title: t('express'), link: '/language-editing/' },
        { title: t('translation'), link: '/language-translation-services/' },
        { title: t('latex'), link: '/language-editing-services/latex-editing/' },
        { title: t('phdThesis'), link: '/language-editing-services/phd-thesis-editing' },
        { title: t('groupDeals'), link: '/group-deals/' },
      ],      
      language: [
        {
          title: 'English',
          link: getLink('localeGlobal'),
        },
        {
          title: '中国 - 简体中文',
          link: getLink('localeCn'),
        },
      ],
    }


    if (user.isLoggedIn) {
      initials = user.customerFullname
      initials = initials.match(/\b\w/g) || []
      initials = (
        (initials.shift() || '') + (initials.pop() || '')
      ).toUpperCase()
    }

    const blogLink = i18n.language === 'zh' ? 'blogCn' : 'blog'

    return (
      <StyledHeader
        id="gh-cnt"
        className={`highlight-none ${popupOpen ? 'open' : ''}`}
      >
        <ChatScript currentLanguage={i18n.language}/>
        <div
          id="gh-main-cnt"
          className="u-flex-center-ver u-position-relative gh-sides-padding"
        >
          <Link id="gh-branding" className="u-flex-center-ver" to="/">
            <LogoSvg />
            <StyledTitle>{t('languageServices')}</StyledTitle>
          </Link>
          <StyledHeaderNav id="gh-nav-cnt" className="u-flex-center-ver">
            <nav aria-label="links" className="gh-nav gh-nav-links gh-nav-h">
              <ul className="gh-nav-list u-list-reset">
                <li className="gh-nav-item gh-move-to-spine">
                  <HoverMenu
                    to="/language-editing/"
                    label={t('languageEditing')}
                    menuItems={menuLinks.languageEditing}
                  />
                </li>
                <li className="gh-nav-item gh-move-to-spine">
                  <a
                    className="anchor button-link-primary gh-nav-action"
                    href={getLink(blogLink)}
                    id="5dfa035a-1b45-4b54-9bb8-dc50cf439c21"
                    data-aa-region="aa-globalheader-navigation-link1"
                    data-aa-name="aa-globalheader-navigation-Author Guidance"
                    target="_blank"
                  >
                    <StyleMenuItemSpan className="anchor-text">{t('authorGuidance')}</StyleMenuItemSpan>
                  </a>
                </li>
                <li className="gh-nav-item gh-move-to-spine">
                  <a
                    className="anchor button-link-primary gh-nav-action"
                    href="https://service.elsevier.com/app/home/supporthub/webshop/"
                    id="5dfa035a-1b45-4b54-9bb8-dc50cf439c21"
                    data-aa-region="aa-globalheader-navigation-link1"
                    data-aa-name="aa-globalheader-navigation-Help"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <IconSVG>
                      <svg width="20" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M1.59636 6.08476C3.00636 2.82601 6.43949 0.568514 10.0001 0.621014C11.4851 0.619139 12.9664 0.982889 14.277 1.67851C17.4232 3.29664 19.4351 6.84789 19.1707 10.3804C18.9964 14.0835 16.3245 17.4885 12.7845 18.5685C9.47886 19.6523 5.61636 18.6416 3.27636 16.0635C0.790115 13.4648 0.10574 9.35664 1.59636 6.08476ZM17.1982 8.14351C16.4951 4.87539 13.3451 2.36101 10.0001 2.42101C7.50261 2.39476 5.07074 3.74851 3.75074 5.86351C1.94324 8.61976 2.33699 12.5573 4.65449 14.901C6.88574 17.3254 10.7932 17.9066 13.6357 16.2416C16.4389 14.7116 17.9689 11.2448 17.1982 8.14351ZM10.1876 4.74601C8.48511 4.74601 7.18761 5.87101 7.18761 7.74601H9.06261C9.06261 6.99601 9.43761 6.24601 10.1876 6.24601C10.9376 6.24601 11.3876 6.71101 11.2976 7.45726C11.2399 7.91706 10.8441 8.24794 10.4012 8.61819C9.77845 9.13874 9.06261 9.73712 9.06261 10.881V11.496H10.9376V11.121C10.9376 10.5094 11.402 10.0805 11.9088 9.61232C12.5176 9.04997 13.1876 8.43104 13.1876 7.37101C13.1876 5.87101 11.9089 4.74601 10.1876 4.74601ZM9.06261 14.496V12.621H10.9376V14.496H9.06261Z" fill="#2E2E2E" />
                      </svg>
                    </IconSVG>
                  </a>
                </li>
                <li className="gh-nav-item gh-move-to-spine">
                  <LanguageMenu title={t('language')} languageSelect={t(i18n.language)} />
                </li>
                <li className="gh-nav-item gh-move-to-spine">
                <StyledMenuItem>
                  <StyledCurrencyTitle>{t('currency')} |</StyledCurrencyTitle>
                  <StyledSelectCurrency className="phd-currency-calc">
                    <option value="usd">USD - $</option>
                    <option value="eur">EUR - €</option>
                    <option value="jpy">JPY - ¥</option>
                    <option value="gbp">GBP - £</option>
                  </StyledSelectCurrency>
                  </StyledMenuItem>
                </li>

              </ul>
            </nav>{' '}
          </StyledHeaderNav>
          <nav
            aria-label="profile"
            className="gh-nav gh-nav-utilities gh-nav-h"
          >
            <ul className="gh-nav-list u-list-reset">
              <li className="gh-nav-item gh-has-dd">
                <div className="gh-profile-container">
                  <div
                    id="gh-profile-cnt"
                    className="u-margin-left-m u-flex-center-ver gh-move-to-spine"
                  >
                    <div
                      className={`gh-ppvr ${popupOpen ? 'gh-is-expanded' : ''}`}
                      id="gh-profile-dd"
                      aria-label="Profile settings"
                    >
                      {user.isLoggedIn ? (
                        <>
                          <button
                            type="button"
                            tabIndex="0"
                            aria-label="Profile settings"
                            title="Profile settings"
                            className="gh-avatar u-flex-center-ver gh-sm"
                            onClick={setPopup}
                          >
                            <span className="gh-initials">
                              <span className="gh-sr-only">User initials</span>
                              {initials}
                            </span>
                          </button>
                        </>
                      ) : (
                        <>
                          <div className="gh-ppvr-trigger">
                            <a href={getLink('myDeskUrl')} aria-label="Sign In">
                              <button
                                className="button-link button-medium gh-icon-btn gh-move-to-spine button-link-primary gh-nav-action"
                                id="gh-signin-btn"
                                type="button"
                              >
                                <svg
                                  focusable="false"
                                  role="img"
                                  viewBox="0 0 106 128"
                                  width="19.875"
                                  height="24"
                                  className="gh-icon icon-person"
                                >
                                  <path d="m11.07 1.2e2l0.84-9.29c1.97-18.79 23.34-22.93 41.09-22.93 17.74 0 39.11 4.13 41.08 22.84l0.84 9.38h10.04l-0.93-10.34c-2.15-20.43-20.14-31.66-51.03-31.66s-48.89 11.22-51.05 31.73l-0.91 10.27h10.03m41.93-102.29c-9.72 0-18.24 8.69-18.24 18.59 0 13.67 7.84 23.98 18.24 23.98s18.24-10.31 18.24-23.98c0-9.9-8.52-18.59-18.24-18.59zm0 52.29c-15.96 0-28-14.48-28-33.67 0-15.36 12.82-28.33 28-28.33s28 12.97 28 28.33c0 19.19-12.04 33.67-28 33.67" />
                                </svg>
                              </button>
                            </a>
                          </div>
                        </>
                      )}
                      {!user.isLoggedIn ? (
                        ''
                      ) : (
                        <>
                          <div
                            id="gh-ppvr-cnt-gh-profile-dd"
                            className="gh-ppvr-cnt gh-ppvr-right"
                          >
                            <div className="gh-ppvr-arrow-cnt">
                              <div className="gh-ppvr-arrow gh-arrow-right">
                                <div className="u-position-relative">
                                  <div className="gh-ppvr-arrow-fill" />
                                </div>
                              </div>
                            </div>
                            <div className="gh-ppvr-cnt-inner">
                              <div className="gh-user-info u-flex-center-ver u-margin-bottom-m">
                                <div
                                  aria-label=""
                                  title=""
                                  className="gh-avatar u-flex-center-ver gh-md"
                                >
                                  <span className="gh-initials">
                                    <span className="gh-sr-only">
                                      User initials
                                    </span>
                                    {initials}
                                  </span>
                                </div>
                                <ul className="u-list-reset u-margin-left-s">
                                  <li className="gh-user-fname">
                                    {user.customerFullname}
                                  </li>
                                </ul>
                              </div>
                              <ul className="gh-dd-nav">
                                <li className="gh-nav-item">
                                  <a
                                    className="anchor button-link-primary gh-nav-action"
                                    href={getLink('myAuthorServices')}
                                    tabIndex="0"
                                    id="701fbc01-d0e7-494c-8f8d-38ab73963ffe"
                                    data-aa-region="aa-globalheader-profile2"
                                    data-aa-name="aa-globalheader-profile-Personalization"
                                  >
                                    <span className="anchor-text">
                                      My author services
                                    </span>
                                  </a>
                                </li>
                              </ul>
                              <StyledButtons className="gh-dd-actions">
                                <a
                                  href={getLink('myProfile')}
                                  className="button button-medium button-tertiary"
                                  aria-label="View account"
                                >
                                  <span className="button-text">
                                    View account
                                  </span>
                                </a>
                                <a
                                  href={getLink('logout')}
                                  className="button button-medium button-primary"
                                  aria-label="Sign Out"
                                >
                                  <span className="button-text">Sign out</span>
                                </a>
                              </StyledButtons>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
          <div id="gh-mobile-menu">
            <div className="gh-hamburger u-fill-grey7 u-margin-left-m">
              <button
                className="button-link button-medium u-flex-center-ver button-link-primary"
                aria-label="Toggle mobile menu"
                aria-expanded="false"
                type="button"
                onClick={() => setMenuOpen(true)}
              >
                <svg
                  className="gh-hamburger-svg-el gh-hamburger-closed"
                  role="img"
                  aria-hidden="true"
                  height="18"
                  width="40"
                >
                  <path d="M0 14h40v2H0zm0-7h40v2H0zm0-7h40v2H0z" />
                </svg>
              </button>
            </div>
            <div
              id="gh-drawer"
              aria-label="Mobile menu"
              role="navigation"
              style={{
                right: menuOpen ? 0 : '-320px',
                visibility: menuOpen ? 'visible' : 'hidden',
                paddingBottom: '16px',
              }}
            >
              <header id="gh-drawer-header" className="u-padding-s-xs text-s">
                <div className="gh-hamburger u-margin-left-s">
                  <button
                    className="button-link button-medium u-flex-center-ver button-link-primary"
                    aria-label="Toggle mobile menu"
                    aria-expanded="true"
                    type="button"
                    onClick={() => setMenuOpen(false)}
                  >
                    <svg
                      xmlns="https://www.w3.org/2000/svg"
                      role="img"
                      aria-hidden="true"
                      className="gh-hamburger-open"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                    >
                      <rect
                        x="9.01"
                        y="-2.95"
                        width="1.97"
                        height="25.91"
                        transform="translate(9.86 -4.29) rotate(45)"
                      />
                      <rect
                        x="9.01"
                        y="-2.95"
                        width="1.97"
                        height="25.91"
                        transform="translate(24 9.86) rotate(135)"
                      />
                    </svg>
                  </button>
                </div>
                <div className="gh-dh-opt">
                  {user.isLoggedIn ? (
                    <div
                      aria-label="Profile image"
                      title="Profile image"
                      className="gh-avatar u-flex-center-ver u-margin-right-s gh-xs"
                    >
                      <span className="gh-initials">
                        <span className="gh-sr-only">User initials</span>
                        {initials}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="gh-dh-profile">
                    {user.isLoggedIn ? (
                      ''
                    ) : (
                      <p className="u-margin-bottom-s">
                        Make use of personalized features like alerts and saved
                        searches
                      </p>
                    )}
                    <div className="gh-dh-actions">
                      <a href={getLink('myDeskUrl')} aria-label="Sign In">
                        <button
                          className="button-link button-medium button-link-secondary"
                          type="button"
                        >
                          <span className="button-link-text">
                            Sign {user.isLoggedIn ? 'out' : 'in'}
                          </span>
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </header>
              <div id="gh-mob-inst-cnt" />
              <nav
                aria-label="links"
                className="gh-nav gh-nav-links gh-nav-v"
                style={{ marginTop: '16px' }}
              >
                <ul className="gh-nav-list u-list-reset">
                  <li className="gh-nav-item">
                    <a
                      className="anchor button-link-primary gh-nav-action"
                      href="/"
                      tabIndex="0"
                    >
                      <MobileMenuTitle className="anchor-text">
                        {t('languageEditing')}
                      </MobileMenuTitle>
                    </a>
                    <MobileMenuItem menuItems={menuLinks.languageEditing} />
                  </li>
                  <li className="gh-nav-item">
                    <a
                      className="anchor button-link-primary gh-nav-action"
                      href={getLink(blogLink)}
                      tabIndex="0"
                    >
                      <MobileMenuTitle className="anchor-text">
                        {t('authorGuidance')}
                      </MobileMenuTitle>
                    </a>
                  </li>
                  <li className="gh-nav-item">
                    <a
                      className="anchor button-link-primary gh-nav-action"
                      href="https://service.elsevier.com/app/home/supporthub/webshop/"
                      tabIndex="0"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <MobileMenuTitle className="anchor-text">
                        {t('help')}
                      </MobileMenuTitle>
                    </a>
                  </li>
                  <li className="gh-nav-item">
                    <LanguageMenu title={t('language')} languageSelect={t(i18n.language)} />
                  </li>
                  <li className="gh-nav-item">
                    {t('currency')} |
                    <StyledSelectCurrency className="phd-currency-calc">
                      <option value="usd">USD ($)</option>
                      <option value="eur">EUR (€)</option>
                      <option value="jpy">JPY (¥)</option>
                      <option value="gbp">GBP (£)</option>
                    </StyledSelectCurrency>
                  </li>
                </ul>
              </nav>
              {!user.isLoggedIn ? (
                ''
              ) : (
                <nav
                  aria-label="links"
                  className="gh-nav gh-nav-links u-margin-bottom-m gh-nav-v"
                >
                  <ul className="gh-nav-list u-list-reset">
                    <div className="u-clr-grey4 u-margin-bottom-s gh-lbl">
                      Settings
                    </div>
                    <ul className="gh-dd-nav">
                      <li className="gh-nav-item">
                        <a
                          className="anchor button-link-primary gh-nav-action"
                          href={getLink('myAuthorServices')}
                          tabIndex="0"
                        >
                          <span className="anchor-text">
                            My author services
                          </span>
                        </a>
                      </li>
                      <li className="gh-nav-item">
                        <a
                          className="anchor button-link-primary gh-nav-action"
                          href={getLink('myProfile')}
                          tabIndex="0"
                        >
                          <span className="anchor-text">View account</span>
                        </a>
                      </li>
                    </ul>
                  </ul>
                </nav>
              )}
            </div>
          </div>
        </div>
        <div
          id="gh-sub-header"
          className="u-flex-center-ver gh-sides-padding gh-move-to-spine"
        />
        <script id="gh-size-reducer" />
      </StyledHeader>
    )
  }
}

export default Header
